import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snack: {
      snackbar: false,
      text: "",
      color: ""
    },
    loading: false,
    color: process.env.VUE_APP_DEFAULT_SYSTEM_COLOR,
    module: {
      name: "home",
      description: "Home",
      route: "/",
      color: process.env.VUE_APP_DEFAULT_SYSTEM_COLOR
    }
  },
  mutations: {
    SHOW_LOADING(state) {
      state.loading = true;
    },
    HIDE_LOADING(state) {
      state.loading = false;
    },
    SET_SNACK_MESSAGE(state, obj) {
      state.snack.text = obj.text;
      state.snack.color = obj.color;
      state.snack.snackbar = true;
    },
    SET_MODULE(state, module) {
      if (module.color) {
        if (module.color === "default") {
          module.color = process.env.VUE_APP_DEFAULT_SYSTEM_COLOR;
        }
        // state.color = module.color;
      }

      state.module = module;
    },
    SET_COLOR(state, color) {
      if (color === "default") {
        color = process.env.VUE_APP_DEFAULT_SYSTEM_COLOR;
      }
      state.color = color;
    }
  }
});
